import { Flex } from "antd";
import { CSSProperties } from "react";
import styled from "styled-components";

type ContainerProps = {
  children: React.ReactNode;
  textAlign?: string;
}

interface StyledOuterContainerProps {
  textAlign: string;
}

const StyledOuterContainer = styled(Flex)<StyledOuterContainerProps>(({ textAlign }) => `
  margin: 24px;
  text-transform: uppercase;
  flex: 1;
  text-align: ${textAlign};
`);

const styles: { [key: string]: CSSProperties } = {
  innerContainer: {
    maxWidth: 600,
    margin: "auto",
  }
}

export default function Container(props: ContainerProps) {
  return (
    <StyledOuterContainer align="center" textAlign={props.textAlign ?? "center"} vertical>
      <Flex style={styles.innerContainer} vertical gap={16}>
      { props.children }
      </Flex>
    </StyledOuterContainer>
  )
}